import { Groups } from '@/services/groups'

const loadAll = (context) => {
  (new Groups(true)).fetch().then(
    res => context.commit('SET_GROUPS', res.data)
  ).catch(
    e => console.error(e)
  )
}

const load = (context, groupId) => {
  (new Groups(true)).fetch(groupId).then(
    res => context.commit('SET_GROUP', res.data)
  ).catch(
    e => console.error(e)
  )
}

const save = (context, params) => {
  (new Groups(true)).save(params).then(
    res => params.id ? context.commit('UPDATE', params) : context.commit('PUSH', res.data)
  ).catch(
    e => console.error(e)
  )
}

const remove = (context, unitId) => {
  (new Groups(true)).destroy(unitId).then(
    () => context.commit('REMOVE', unitId)
  ).catch(
    e => console.error(e)
  )
}

export default {
  save,
  load,
  remove,
  loadAll
}
